import { IKogModalProps } from "@/main/@types/interfaceIcons";
import React, { useState } from "react";
import * as S from "./styles";
import KogModalSideComponent from "@/main/components/modal/ModalSide";
import HubContainer from "../../../hub/HubContainer";
import { RoutesConstants } from "@/main/routes/routesConstants";
import { useNavigate } from "react-router-dom";
import { SendUpdatesSignalRTypeEnum } from "@/main/services/enum/SendUpdatesSignalRTypeEnum";
import { KOGAreaButtonsModal } from "../../../styles";
import SecondaryButton from "../../../button/secondaryButton";
import { getTranslateByKey } from "@/main/services/utils";
import { useDispatch } from "react-redux";
import { signalRClearReceiveUpdatesByKey } from "@/main/store/signalR";

interface IModalRequoteSignalRProps extends IKogModalProps {
	claimNumber: string;
}

function ModalRequoteSignalR({ claimNumber, closeModal, setIsOpenModal }: IModalRequoteSignalRProps) {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const signalRType = SendUpdatesSignalRTypeEnum.RequoteNational;

	const [isLoadingSignalR, setIsLoadingSignalR] = useState<boolean>(false);
	const [isErrorSignalR, setIsErrorSignalR] = useState<boolean>(false);

	function onFinishedRequote() {
		if (isLoadingSignalR) {
			if (location.pathname == RoutesConstants.orderSearchOrder) {
				navigate("/temp");
			}

			const routeRedirect = `${RoutesConstants.orderSearchOrder}?quoteFilterVehicle=${claimNumber}`;
			navigate(routeRedirect);
			setIsLoadingSignalR(false);
			setIsOpenModal(false);
			// setIsQuoteBlocked(false);
		}
	}
	function onErrorRequote() {
		setIsLoadingSignalR(false);
		setIsErrorSignalR(true);
		// setIsQuoteBlocked(false);
	}

	React.useEffect(() => {
		return () => {
			if (isErrorSignalR) {
				dispatch(signalRClearReceiveUpdatesByKey(signalRType));
			}
		};
	}, [dispatch, isErrorSignalR, signalRType]);

	return (
		<S.Container>
			<HubContainer
				type={signalRType}
				customProps={{
					onFinishedRequote: onFinishedRequote,
					onErrorRequote: onErrorRequote,
				}}
			/>
			<KOGAreaButtonsModal>
				<SecondaryButton size="small" id="id-createOrder-btn-back" type="button" onClick={closeModal}>
					{getTranslateByKey("information.back")}
				</SecondaryButton>
			</KOGAreaButtonsModal>
		</S.Container>
	);
}

function WrapperModalRequoteSignalR(props: IModalRequoteSignalRProps) {
	return (
		<KogModalSideComponent open={props.isOpenModal} closeModal={props.closeModal}>
			{props.isOpenModal ? <ModalRequoteSignalR {...props} /> : <div />}
		</KogModalSideComponent>
	);
}

export default WrapperModalRequoteSignalR;
